import {useParams} from 'react-router';
import HistoryTripDetail from '@di-shared/features/history/trip-detail/HistoryTripDetail';

interface HistoryTripDetailPageProps {
  vin: string;
}

export default function HistoryTripDetailPage({vin}: HistoryTripDetailPageProps) {
  const {tripId} = useParams<{tripId: string}>();

  if (!tripId) {
    return null;
  }

  return (
    <HistoryTripDetail
      vin={vin}
      tripId={tripId}
    />
  );
}